import { render, staticRenderFns } from "./cell-renderer-aktionen-katalog-reisen.vue?vue&type=template&id=1be769c2"
import script from "./cell-renderer-aktionen-katalog-reisen.vue?vue&type=script&lang=js"
export * from "./cell-renderer-aktionen-katalog-reisen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports